import { useId } from "react";

/**
 * "Le Fil" — the signature animated arc connecting two people/places,
 * with a glowing dot travelling along the thread (3.5s ease-in-out loop).
 */
export function LeFil({
  from = "You",
  to = "Them",
  showLabels = true,
  className = "",
  strokeWidth = 2,
}) {
  const id = useId().replace(/:/g, "");
  const gradId = `fil-grad-${id}`;
  const glowId = `fil-glow-${id}`;
  const pathId = `fil-path-${id}`;
  const path = "M46,132 C140,20 260,20 354,132";

  return (
    <svg
      viewBox="0 0 400 160"
      className={className}
      role="img"
      aria-label={`Connection between ${from} and ${to}`}
      fill="none"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#9C4A50" />
          <stop offset="50%" stopColor="#E8A33D" />
          <stop offset="100%" stopColor="#7C9473" />
        </linearGradient>
        <filter id={glowId} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="5" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* the thread */}
      <path
        id={pathId}
        d={path}
        stroke={`url(#${gradId})`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        opacity="0.85"
      />

      {/* endpoints */}
      <g>
        <circle cx="46" cy="132" r="6" fill="#9C4A50" />
        <circle cx="46" cy="132" r="11" fill="#9C4A50" opacity="0.18" />
        <circle cx="354" cy="132" r="6" fill="#7C9473" />
        <circle cx="354" cy="132" r="11" fill="#7C9473" opacity="0.18" />
      </g>

      {/* travelling glow */}
      <circle r="13" fill="#F4C878" opacity="0.35" filter={`url(#${glowId})`}>
        <animateMotion
          dur="3.5s"
          repeatCount="indefinite"
          calcMode="spline"
          keyPoints="0;1;0"
          keyTimes="0;0.5;1"
          keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
          path={path}
        />
      </circle>
      {/* travelling dot */}
      <circle r="5" fill="#E8A33D">
        <animateMotion
          dur="3.5s"
          repeatCount="indefinite"
          calcMode="spline"
          keyPoints="0;1;0"
          keyTimes="0;0.5;1"
          keySplines="0.42 0 0.58 1;0.42 0 0.58 1"
          path={path}
        />
      </circle>

      {showLabels && (
        <g className="font-mono-num" fill="currentColor">
          <text x="46" y="152" textAnchor="middle" fontSize="12" letterSpacing="0.05em">
            {from}
          </text>
          <text x="354" y="152" textAnchor="middle" fontSize="12" letterSpacing="0.05em">
            {to}
          </text>
        </g>
      )}
    </svg>
  );
}
